import React from 'react';
import { connect } from 'react-redux';
import Autorizacao from '../../security/Autorizacao';
import { PERFIL_ADMIN, getAdminEmpresa, getOperadorRemarcacao } from '../../security/securityContext';
import Titulo from '../comum/Titulo';
import qs from 'qs';
import { buscarReservasItinerario } from '../../actions/reserva/buscarReservasItinerario';
import buscarItinerario from '../../actions/itinerario/buscarItinerario';
import capitalizarTodasPrimeirasLetras from '../../util/capitalizarTodasPrimeirasLetras';
import alterarReservaItinerario from '../../actions/reserva/alterarReservaItinerario';
import alterarTodasReservasItinerario from '../../actions/reserva/alterarTodasReservasItinerario';
import selecionarReservasTransferencia from '../../actions/reserva/selecionarReservasTransferencia';

export class PainelTransferirPassageirosItinerarios extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            reservas: [],
            itinerarioDestinoSelecionado: null,
            marcado: false,
            retorno: '/painel-itinerarios'
        };
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.handleMarcarDesmarcarTodos = this.handleMarcarDesmarcarTodos.bind(this);
        this.setReservas = this.setReservas.bind(this);
    }

    componentDidMount() {
        const parametros = qs.parse(this.props.history.location.search, { ignoreQueryPrefix: true });
        this.props.selecionarReservasTransferencia([]);
        if (parametros.itinerario) {
            this.props.buscarItinerario(this.props.empresaSelecionada.id, parametros.itinerario)
            this.props.buscarReservasItinerario(parametros.itinerario, this.props.empresaSelecionada.id);
        } else {
            this.props.history.push('/painel-itinerarios');
        }
    }

    setReservas(reservas) {
        this.setState({ reservas, marcado: !this.props.marcado });
    }

    handleAvancarClick = () => {
        const parametros = qs.parse(this.props.history.location.search, { ignoreQueryPrefix: true });
        const queryParams = `?itinerario=${parametros.itinerario}`;
        this.props.selecionarReservasTransferencia(this.state.reservas);
        this.props.history.push(`/itinerarios-para-transferencia${queryParams}`);
    }

    handleMarcarDesmarcarTodos() {
        if (this.state.marcado) {
            this.setState({ reservas: [], marcado: false });
            this.props.alterarTodasReservasItinerario(false);
        } else {
            const reservas = [...this.props.reservas];
            this.setState({ reservas, marcado: true });
            this.props.alterarTodasReservasItinerario(true);
        }
    }

    handleCheckboxChange(reserva) {
        if (reserva.marcado) {
            const reservas = [...this.state.reservas].filter(it => !(it.id == reserva.id));
            this.setState({ reservas });
            this.props.alterarReservaItinerario(reserva);
        } else {
            const reservas = [...this.state.reservas];
            reservas.push(reserva);
            this.setState({ reservas });
            this.props.alterarReservaItinerario(reserva);
        }
    }

    exibir() {
        if (this.props.reservas && this.props.reservas.length) {
            return <React.Fragment>
                <table className="table-responsive table table-striped table-bordered" data-show-print={true}>
                    <thead>
                        <tr>
                            <td colSpan={13} className='text-center'><strong>{this.props.empresaSelecionada.nome}</strong>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2}><strong>Prefixo:</strong> {this.props.itinerarioSelecionado.rotaDto.prefixo}
                            </td>
                            <td colSpan={8}>
                                <strong>Veículo:</strong> {this.props.itinerarioSelecionado.veiculoDto.descricao}</td>
                            <td colSpan={3}><strong>Total de
                                passageiros:</strong> {this.props.reservas.length}</td>
                        </tr>
                        <tr>
                            <td colSpan={4}>
                                <strong>Origem:</strong> {`${this.props.itinerarioSelecionado.rotaDto.cidadeOrigem.nome} (${this.props.itinerarioSelecionado.rotaDto.cidadeOrigem.uf}) - ${this.props.itinerarioSelecionado.dataHoraPartida}`}
                            </td>
                            <td colSpan={4}>
                                <strong>Destino:</strong> {`${this.props.itinerarioSelecionado.rotaDto.cidadeDestino.nome} (${this.props.itinerarioSelecionado.rotaDto.cidadeDestino.uf}) - ${this.props.itinerarioSelecionado.dataHoraChegada}`}
                            </td>
                            <td colSpan={2}>
                                <strong>ID Rota:</strong> {this.props.itinerarioSelecionado.rotaDto.id}
                            </td>
                            <td colSpan={3}>
                                <strong>ID Itinerário:</strong> {this.props.itinerarioSelecionado.id}
                            </td>
                        </tr>
                        {this.props.itinerarioSelecionado.prestador ?
                            <tr>
                                <td colSpan={13}>
                                    <strong>Prestador: </strong>{this.props.itinerarioSelecionado.prestador.valor}
                                </td>
                            </tr> : ''}
                        <tr>
                            <th scope="col">Selecionar passageiros
                                <input type="checkbox" checked={this.props.marcado} onChange={() => this.handleMarcarDesmarcarTodos()}/>
                            </th>
                            <th scope="col">Poltrona</th>
                            <th scope="col">Pedido</th>
                            <th scope="col">Vendedor</th>
                            <th scope="col">Nome</th>
                            <th scope="col">Verificador</th>
                            <th scope='col'>Telefone</th>
                            <th scope="col">Trecho</th>
                            <th scope="col">Tipo de passagem</th>
                            <th scope="col">Documento</th>
                            <th scope="col">Data/Hora embarque</th>
                            <th scope="col">Data/Hora desembarque</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.exibirCorpoTabela()}
                    </tbody>
                </table>
                <button className="btn btn-laranja float-right" onClick={this.handleAvancarClick}
                    disabled={this.state.reservas.length <= 0}>
                    Avançar
                </button>

            </React.Fragment>
        }
        return <div className="alert alert-warning text-center" role="alert">
            Itinerário não possui passagens vendidas
        </div>
    }

    tipoDocumentoEhPassaporteOuOutros(passageiro) {
        return passageiro.tipoDocumento == 'PASSAPORTE' || passageiro.tipoDocumento == 'OUTROS'
    }

    selecionarReserva(reserva) {
        this.setState({ reservaSelecionada: reserva })
    }

    exibirCorpoTabela() {
        return this.props.reservas.map(reserva => <tr key={reserva.id}>
            <td>
                <input type="checkbox" checked={reserva.marcado} onChange={() => this.handleCheckboxChange(reserva)} />
            </td>
            <td scope="row">{reserva.numeroPoltrona}</td>
            <td>{reserva.pedidoId}</td>
            <td>{reserva.nomeVendedor}</td>
            <td>
                <div>{capitalizarTodasPrimeirasLetras(reserva.passageiroDto.nome)}</div>
                {reserva.passageiroDto.criancaDto ? <div>
                    <strong>Criança: </strong>{capitalizarTodasPrimeirasLetras(reserva.passageiroDto.criancaDto.nome)}
                </div> : ''}
            </td>
            <td>{this.tipoDocumentoEhPassaporteOuOutros(reserva.passageiroDto) ? reserva.passageiroDto.documentoComFoto : reserva.passageiroDto.cpfPassageiro}</td>
            <td>{reserva.passageiroDto.telefone ? reserva.passageiroDto.telefone : 'Não informado'}</td>
            <td>{`${reserva.descCidadeOrigem} -> ${reserva.descCidadeDestino}`}</td>
            <td>{reserva.passageiroDto.descTipoEmissao}</td>
            <td>{reserva.passageiroDto.documentoComFoto}</td>
            <td>{reserva.dataHoraEmbarque ? reserva.dataHoraEmbarque : 'Não embarcado'}</td>
            <td>{reserva.dataHoraDesembarque ? reserva.dataHoraDesembarque : 'Não desembarcado'}</td>
        </tr>)
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getAdminEmpresa(this.props.itinerarioSelecionado.idEmpresa),
                getOperadorRemarcacao(this.props.itinerarioSelecionado.idEmpresa)]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <h1 className='printer-element col-12 text-center mb-4'>LISTA DE PASSAGEIROS</h1>
                <div className="row internas" id='table-responsive'>
                    <Titulo texto="Lista de passageiros" urlRetorno={this.state.retorno} />
                    <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
                        <div className="lista-table">                            
                            {this.exibir()}
                        </div>
                    </div>
                </div>
            </Autorizacao>
        );
    }
}

export function mapStateToProps(state) {
    return {
        reservas: state.transferenciaReservasItinerario.reservas,
        itinerarioSelecionado: state.itinerarioSelecionado,
        empresaSelecionada: state.empresaSelecionada
    }
}

export default connect(mapStateToProps, {
    buscarItinerario,
    buscarReservasItinerario,
    alterarReservaItinerario,
    alterarTodasReservasItinerario,
    selecionarReservasTransferencia
})(PainelTransferirPassageirosItinerarios);